/**
 * 公司管理
 */
import request from "@/utils/request";


/**
 * 查询公司列表
 */
export function list(param) {
  return request({
    url: "/base/corp/list",
    method: "post",
    data: param
  });
}

/**
 * 查询公司树
 */
export function listTree(param) {
  return request({
    url: "/base/corp/listTree",
    method: "post",
    data: param
  });
}

/**
 * 根据PK查询单据
 */
export function get(pk) {
  return request({
    url: "/base/corp/get/" + pk,
    method: "get"
  });
}

/**
 * 保存单据
 */
export function save(data) {
  return request({
    url: "/base/corp/save",
    method: "post",
    data: data
  });
}

/**
 * 封存
 */
export function seal(pk) {
  return request({
    url: "/base/corp/seal/" + pk,
    method: "get"
  });
}

/**
 * 启用
 */
export function unseal(pk) {
  return request({
    url: "/base/corp/unseal/" + pk,
    method: "get"
  });
}



// WEBPACK FOOTER //
// ./src/api/base/corp.js